import { render, staticRenderFns } from "./searchCommunityDataList.vue?vue&type=template&id=68c1fae7&scoped=true"
import script from "./searchCommunityDataList.vue?vue&type=script&lang=js"
export * from "./searchCommunityDataList.vue?vue&type=script&lang=js"
import style0 from "./searchCommunityDataList.vue?vue&type=style&index=0&id=68c1fae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1fae7",
  null
  
)

export default component.exports